<script>
import FormatMixins from '@/mixins/FormatMixins'
import iconEye from '@/assets/images/ic-eye-primary.jpg'
import iconEyeOff from '@/assets/images/ic-eye-off-primary.jpg'

export default {
   name: 'HomeAccountData',
   mixins: [FormatMixins],
   props: ['accountInfo', 'user', 'subType'],
   computed: {
      processStyle() {
         // console.log('user',this.user);
         return {
            width: '80%'
         }
      },

      iconToggleShowInfo() {
         return this.showInfo ? iconEye : iconEyeOff
      }
   },
   emits: ['onClickFunction'],
   data() {
      return {
         showInfo: false
      }
   }
}
</script>

<template>
   <div :class="parseInt(user.status) === 1 ? ['acc-auth', 'acc-auth--data'] : ['acc-auth', 'acc-auth--data', 'none']">
      <div class="box-data">
         <div class="box-data__list">
            <div
               v-if="subType == 1"
               class="box-data__item"
               @click="$emit('onClickFunction', '/mobile/info?tab=account')"
            >
               <h5 class="box-data__name">
                  {{ $t('mobile.home.main_account') }}
               </h5>
               <span class="box-data__value">
                  <template>
                     {{ formatNumber(accountInfo.mainAcc) }}
                  </template>
                  <span class="box-data__value__unit">{{ $t('unit.upper_kip') }}</span>
               </span>
            </div>

            <div
               v-if="subType == 2"
               class="box-data__item"
               @click="$emit('onClickFunction', '/mobile/info?tab=account')"
            >
               <h5 class="box-data__name">
                  {{ $t('mobile.home.hot_change') }}
               </h5>
               <span class="box-data__value">
                  {{ formatNumber(accountInfo.prePost) }}
                  <span class="box-data__value__unit">{{ $t('unit.upper_kip') }}</span>
               </span>
            </div>

            <div style="position: relative">
               <a @click="$emit('onClickFunction', '/ucare/customer-service/home')" class="nav-bar__images"
                  ><img src="/img/ic-u-care.e037e8b3.svg" alt="img" /></a
               >
               <button
                  class="box-data__button button button--primary"
                  @click="$emit('onClickFunction', '/mobile/recharge')"
               >
                  Top up
               </button>
            </div>
         </div>

         <hr />
         <div class="process-data process-data--full" @click="$emit('onClickFunction', '/mobile/info?tab=account')">
            <div class="process-data__top">
               <div class="process-data__info">
                  <h4 class="process-data__name">
                     {{ $t('mobile.account_information.data') }}
                  </h4>
               </div>
               <div class="process-data__capacity">
                  <span class="process-data__capacity-use"></span>
                  <span class="data--value data--value__primary data--value__small">
                     <template>
                        {{ formatNumber(accountInfo.dataVolume) }}
                        <span class="data--unit data--unit__small">{{ $t('unit.mb') }}</span>
                     </template>
                  </span>
               </div>
            </div>
            <div class="process-bar">
               <p :style="processStyle" class="process-bar__percent"></p>
            </div>
         </div>
      </div>
   </div>
   <!-- <div
         :class="
                  parseInt(user.status) === 1 ? ['acc-auth', 'acc-auth--data'] : ['acc-auth', 'acc-auth--data', 'none']
               "
         class="mt-2"
      >
         <div class="box-data">
            <a class="box-data__link" @click="redirectTo('/ucare/customer-service/home')">
               <span class="box-data__icon"><img alt="img" src="@/assets/images/ic-loyalty-2.svg" /></span>
            </a>
            <ul v-if="subType === 1" class="box-data__list">
               <li class="box-data__item" @click="onClickFunction('/mobile/info?tab=account')">
                  <h5 class="box-data__name">
                     {{ $t('mobile.home.main_account') }}
                  </h5>
                  <span class="box-data__value">
                           {{
                        Number(accountInfo.mainAcc).toLocaleString('en-US', {
                           maximumFractionDigits: 0
                        })
                     }}
                           <span>{{ $t('unit.upper_kip') }}</span></span
                  >
               </li>
            </ul>
            <ul v-if="subType === 2" class="box-data__list">
               <li class="box-data__item" @click="onClickFunction('/mobile/info?tab=account')">
                  <h5 class="box-data__name">
                     {{ $t('mobile.home.hot_change') }}
                  </h5>
                  <span class="box-data__value"
                  >{{
                        Number(accountInfo.prePost).toLocaleString('en-US', {
                           maximumFractionDigits: 0
                        })
                     }}<span>{{ $t('unit.upper_kip') }}</span></span
                  >
               </li>
            </ul>
            <div class="process-data process-data--full" @click="onClickFunction('/mobile/info?tab=account')">
               <div class="process-data__top">
                  <div class="process-data__info">
                     <h4 class="process-data__name">
                        {{ $t('mobile.account_information.data') }}
                     </h4>
                  </div>
                  <div class="process-data__capacity">
                     <span class="process-data__capacity-use"></span>
                     <span class="process-data__capacity-total">
                              {{ Number(accountInfo.dataVolume).toLocaleString('en-US', { maximumFractionDigits: 0 }) }}
                              {{ $t('unit.mb') }}
                           </span>
                  </div>
               </div>
               <div class="process-bar">
                  <p :style="processStyle" class="process-bar__percent"></p>
               </div>
            </div>
         </div>
      </div> -->
</template>

<style lang="scss" scoped>
.acc-auth {
   margin: 0 20px;
   padding: 20px 0 0 0;

   .box-data {
      border-radius: 20px;
      padding: 20px;

      &__list {
         padding: 0;
         display: flex;
         justify-content: space-between;
         align-items: center;
      }

      &__button {
         margin: 0;
         border: none;
         min-width: 75px;
         height: 33px;

         font-size: 11px;
         font-weight: 600;
      }

      &__item {
         margin-bottom: 0;
      }

      &__name {
         font-size: 15px;
         font-weight: 600;
         line-height: 18px;
         color: #000000;
         text-transform: unset;
      }

      &__value {
         font-size: 18px;
         font-weight: 600;
         line-height: 22px;
         color: var(--bs-primary);
         display: flex;
         align-items: center;

         &__unit {
            font-size: 13px;
            font-weight: 400;
            line-height: 16px;
            color: var(--bs-gray-600);
         }

         &.eye__off {
            align-items: end;
         }
      }
      .nav-bar__images {
         align-items: center;
         background-color: var(--bs-white);
         border-radius: 50%;
         bottom: 15px;
         display: flex;
         height: 40px;
         justify-content: center;
         padding: 5px;
         position: absolute;
         right: 17px;
         width: 40px;
         top: -45px;
      }
      .process-data {
         &__top {
            margin-bottom: 10px;
         }

         &__name {
            font-size: 15px;
            font-weight: 600;
            line-height: 18px;
            color: #000000;
            text-transform: unset;
         }
      }
   }

   &.none {
      &::before {
         background-color: transparent;
      }
   }
   
}

</style>
